(function () {
	$(document).ready(function () {
		var laUrl = "//www.lustagenten.com/interface/checkUser3/";
		var style = document.documentElement.style;
		var overflow = style.overflow;
		var top = $(window).scrollTop();
		var active = null;
		var openHandler = function () {};
		var closeHandler = function () {};
		var validateTimer = null;
		var regexp = {};

		var scrollTo = function (e, animate) {
			if (e) {
				e.focus();
				var position = ($(active).scrollTop() || 0) + $(e).offset().top - 15;

				if (animate) {
					$(active).animate({
						scrollTop: position,
						delay: 400,
					});
				} else {
					$(active).scrollTop(position);
				}
			}
		};

		var innerHandler = function (id) {
			active = id.length <= 1 ? null : document.getElementById(id.substr(1));
			if (null === active || !$(active).hasClass("modalDialog") || $(active).hasClass("disabled")) {
				active = null;
				style.overflow = overflow;
				$(window).scrollTop(top);
				closeHandler.call(this);
			} else {
				top = $(window).scrollTop();
				style.overflow = "hidden";

				var forms = active.getElementsByTagName("form");
				if (forms.length > 0) {
					//forms[0].elements.username.focus();
					//scrollTo(forms[0]);
				}
				openHandler.call(this);
			}
		};

		var handler = function () {
			innerHandler(window.location.hash);
		};

		/**
		 * @param href
		 * @param key
		 * @param val if value equals undefined, the key will be removed
		 * @returns {String}
		 */
		var queryParam = function (href, key, val) {
			var a = document.createElement("a");
			a.href = href;
			var s = a.search;
			a.search =
				s.charAt(0) +
				s
					.substring(1)
					.split("&")
					.map(function (arg) {
						return arg.split("=", 2).map(decodeURIComponent);
					})
					.filter(function (arg) {
						return arg.length > 1 && arg[0] !== key;
					})
					.concat([undefined === val ? [] : [key, val]])
					.map(function (arg) {
						return arg.map(encodeURIComponent).join("=");
					})
					.join("&");
			return a.href;
		};

		var focus = function () {
			scrollTo(document.activeElement);
		};

		var keyup = function (e) {
			if (9 === e.keyCode) {
				validateImmediate.call(e.target);
			} else {
				validateDelayed.call(e.target);
			}
		};

		var validateImmediate = function () {
			clearTimeout(validateTimer);
			validate.call(this);
		};

		var validateDelayed = function () {
			var t = this;
			clearTimeout(validateTimer);
			validateTimer = window.setTimeout(function () {
				validate.call(t);
			}, 400);
		};

		var showError = function (element, msg) {
			if ("submit" !== element.type) {
				//element.setCustomValidity(msg);
				element.nextElementSibling.textContent = msg;
			}
		};

		var stop = function () {
			return false;
		};

		var buildDataList = function (input, names) {
			if (input.list) {
				var dlist = input.list;
				dlist.innerHTML = "";
				names = names || [];
				for (var i = 0; i < names.length; i++) {
					var node = document.createElement("option");
					node.value = names[i];
					dlist.appendChild(node);
				}
			}
		};

		// syntax pre-check
		var called = {};
		var request = null;
		var checksPassed = false;

		var validate = function () {
			var t = this;

			var isElement = false;
			var remoteCheck = true;

			checksPassed = false;
			if (t.name in regexp) {
				var matchesPattern = regexp[this.name].test(this.value);
				var hasMinLength = this.value.length >= (this.getAttribute("minlength") || 0);
				var hasMaxLength = this.value.length <= (this.getAttribute("maxlength") || Infinity);
				var isRequired = this.hasAttribute("required");
				remoteCheck = called[this.name] = !isRequired || (hasMinLength && hasMaxLength && matchesPattern);
				isElement = true;
			}

			if (remoteCheck) {
				// start async check now
				var form = this.form;
				var elements = form.elements;
				var username = { value: elements.username.value, enabled: called["username"] || false };
				var email = { value: elements.email.value, enabled: called["email"] || false };

				if (null !== request) {
					request.abort();
				}

				request = $.ajax({
					url: laUrl,
					data: { jscall: "JSON", user_name: username.value, user_email: email.value },
					dataType: "json",
					error: function (xhr, errorType, error) {
						checksPassed = false;
						request = null;
					},
					success: function (data, status, xhr) {
						checksPassed = 0 === data.data.status;

						request = null;
						if (xhr.status !== 200) {
							return;
						}

						if (checksPassed && !isElement) {
							form.submit.call(t);
							return;
						}

						var msg = {};
						var resultCode = data.data.status;
						var nameCode = (resultCode >> 0) & 0xf;
						var emailCode = (resultCode >> 4) & 0xf;

						if (email.enabled && email.value === elements.email.value) {
							msg.email =
								{
									1: "Ungültige E-Mail-Adresse",
									2: "Du musst eine gültige E-Mail-Adresse eingeben",
									4: "Bitte überprüfe deine E-Mail-Adresse auf Tippfehler",
									8: "E-Mail-Adresse ist bereits vergeben",
								}[emailCode] || "";

							showError(elements.email, msg.email);
						}

						if (username.enabled && username.value === elements.username.value) {
							msg.username =
								{
									1: "Ungültiger Benutzername",
									2: "Benutzername ist bereits vergeben",
								}[nameCode] || "";

							buildDataList(elements.username, data.data.userNameSuggestions || []);

							if (0 === nameCode) {
								form.children[1].disabled = false;
							}

							showError(elements.username, msg.username);
						}
					},
				});
			} else {
				if (isElement) {
					switch (this.name) {
						case "username":
							// reverse check
							if (!/[^A-Za-z0-9]/.test(this.value)) {
								return;
							}
							break;

						case "email":
							if (
								false ||
								regexp.email.test(this.value + 'a"@a') ||
								regexp.email.test(this.value + "a@a") ||
								regexp.email.test(this.value + "@a") ||
								regexp.email.test(this.value + "a")
							) {
								return;
							}
							break;
					}

					var msg = this.getAttribute("title");
					if (null !== msg) {
						showError(this, msg);
					}
				}
			}
		};

		var submitHandler = function () {
			return checksPassed;
		};

		$(".modalDialog form").each(function (key, form) {
			$("input[type=text]", form).each(function (index, item) {
				$(item)
					.on("focus", focus)
					.on("keyup", keyup)
					.on("blur", validateImmediate)
					.on("input", validateDelayed);
			});

			regexp.username = /^[A-Za-z0-9]{6,}$/;

			//RFC 5322 / with domain names only
			var rfc5322 =
				/^((?:(?:(?:\x22(?:(?:(?:[\t ]*\r\n)?[\t ]+)?(?:\\[\x00-\x7F]|[^\x00\t\r\n \x22\\\x80-\uFFFF]))*(?:(?:[\t ]*\r\n)?[\t ]+)?\x22)|[\w!#$%\x26\x27*+\/=?^`{|}~-]+)(?:\.(?!@)|(?=@)))+)@([\w!#$%\x26\x27*+\/=?^`{|}~-]+(\.(?!$))?)+/;
			regexp.email = rfc5322;
		});

		$(window).on("hashchange", handler).on("resize", focus);
		handler();

		// export symbol
		window.showSignup = function (elementID, configObj) {
			configObj = configObj || {};
			var closeable = configObj.closeable ? 1 : 0;
			var noWap = configObj.noWap || false;
			var hostName = configObj.hostName || undefined;
			var hostId = configObj.laid || undefined;
			var hostImage = configObj.hostImage || "";
			var hostHTML = configObj.hostHTML || "";
			var submitText = configObj.submitText || "Jetzt anmelden";
			var onOpen = configObj.onOpen || function () {};
			var onClose = configObj.onClose || function () {};

			var element = $(elementID);

			// inject hostName parameter
			$("form", element).each(function (key, form) {
				debugger;
				$(this).on("submit", submitHandler);
				if (hostName !== undefined && hostName !== "") {
					this.action = queryParam(this.action, "p", hostName);
				}
				if (hostId !== undefined && hostId !== null) {
					this.action = queryParam(this.action, "vxid", hostId);
				}
			});

			// if mobile traffic (wap traffic) detected, skip login and redirect to product page
			if (typeof _ismt !== "undefined" && 1 === _ismt) {
				$("form", element).each(function (key, form) {
					var a = document.createElement("a");
					a.href = this.action;
					a.pathname = "";

					form.action = a.href;
					form.method = "GET";
					form.children[0].disabled = true; // 'username-set'
					form.children[1].disabled = true; // 'email-set'

					$("input[type=hidden]", form).each(function (index, item) {
						item.disabled = true;
					});

					$("input[type=submit]", form).each(function (index, item) {
						item.disabled = false;
					});

					if (noWap) {
						window.open(a.href, "_self");
						return;
					}
				});
			}

			var img = $("figure img", element)[0];
			img.alt = hostName;
			img.src = hostImage;
			if ("" === hostImage) {
				$(img).addClass("hidden");
			} else {
				$(img).removeClass("hidden");
			}

			$("figure figcaption", element)[0].innerHTML = hostHTML;
			$("form input[type=submit]", element)[0].value = submitText;

			openHandler = onOpen;
			closeHandler = onClose;
			element.removeClass("disabled");
			if (closeable) {
				window.open(elementID, "_self");
			} else {
				element.addClass("open");
				innerHandler(elementID);
			}
		};
	});
})();
